import { useEffect } from 'react';

const HubSpotTracking = () => {
  useEffect(() => {
    // HubSpot Portal ID
    const HUBSPOT_PORTAL_ID = '146741976';

    // Load HubSpot tracking code
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'hs-script-loader';
    script.async = true;
    script.defer = true;
    script.src = `//js.hs-scripts.com/${HUBSPOT_PORTAL_ID}.js`;
    document.body.appendChild(script);

    return () => {
      // Cleanup if component unmounts
      const existingScript = document.getElementById('hs-script-loader');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return null;
};

export default HubSpotTracking;
